import React, { useEffect, useRef, useState } from "react";

import Typography from "../../../../../Typography";

import { ReactComponent as ArrowDownIcon } from "../../../../../../build/images/nps-dashboard-icons/arrow-down.svg";

import "./status-select.css";

export default function StatusSelect({
    selectedStatus,
    onChange,
    statusOptions = [
        // {
        //     "id": 4,
        //     "description": "Concluído"
        // },
        {
            "id": 2,
            "description": "Em tratativa"
        },
        {
            "id": 1,
            "description": "Novo"
        },
        {
            "id": 3,
            "description": "Não conformidade"
        }
    ],
    setSelectedStatus,
    treatmentData
}) {
    const selectRef = useRef();

    const [isOpen, setIsOpen] = useState(false);

    const handleStatusChange = (status,nameStatus) => {
        setIsOpen(false);
        onChange(status,nameStatus);
    };

    const getTagBackground = (id) => {
        let colorOption = statusOptions.find((status) => status.id === id);
        if(colorOption){
            return colorOption.class_color
        }else{
            return "#455cc7"
        }
        // switch (id) {
        //     case null:
        //     case 1:
        //         return "#455cc7";
        //     case 2:
        //         return "#F2BD00";
        //     case 3:
        //         return "#C90000";
        //     case 4:
        //         return "#008908";
        //     default:
        //         break;
        // }
    };

    const getStatusText = () => {
        const selectedOption = statusOptions.find((status) => status.id === selectedStatus);

        if (selectedOption) {
            return selectedOption.description;
        } else if (treatmentData.id_deal_status === null || treatmentData.id_deal_status === 1) {
            return "Novo";
        // } else if (treatmentData.id_deal_status === 2) {
        //     return "Em tratativa";
        // } else if (treatmentData.id_deal_status === 3) {
        //     return "Não conformidade";
        // } else if (treatmentData.id_deal_status === 4) {
        //     return "Concluído";
        } else {
            return "";
        }
    };

    const handleOutsideClick = (e) => {
        if (selectRef.current && !selectRef.current.contains(e.target)) {
            // Verifica se o clique ocorreu fora do componente e se o clique não ocorreu em uma opção
            const isOptionClick = e.target.closest('.status-options');

            if (!isOptionClick) {
                setIsOpen(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        setSelectedStatus(treatmentData.id_deal_status)
    }, [treatmentData.id_deal_status])

    return (
        <div
            ref={selectRef}
            className={`status-select-container ${isOpen ? 'open' : ''}`}
        >
            <div
                className="status-select-content"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div
                    className="status-select-content__tag"
                    style={{ background: getTagBackground(selectedStatus) }}
                >
                    <span className="status-select-content__tag__span" />

                    <Typography.H5 weight="500" color="white">
                        {getStatusText()}
                    </Typography.H5>
                </div>

                <ArrowDownIcon className={isOpen ? "rotated" : ""} />
            </div>

            {isOpen && (
                <div className="status-options">
                    {statusOptions.filter((status) => status.id !== 4).map((status) => (
                        <div
                            key={status.id}
                            className="status-option"
                            onClick={() => handleStatusChange(status.id,status.description)}
                        >
                            {status.description}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
